import axios from "axios";
import { Initial } from "redmond";
import {
  IOfferAvailabilityRequest,
} from "redmond/hotels-module/interfaces";
import { config } from "../../config";
import { lodgingOffersAvailabilityApiPrefix } from "../paths";

export const fetchPremiumCollectionOffersAvailability = async (
  body: IOfferAvailabilityRequest
): Promise<Initial> => {
  const res = await axios.post(lodgingOffersAvailabilityApiPrefix, body, {
    baseURL: config.baseURL,
  });
  return res.data;
};
